import { render } from "./FileTypeSelector.vue?vue&type=template&id=0c98df39&ts=true"
import script from "./FileTypeSelector.vue?vue&type=script&lang=ts"
export * from "./FileTypeSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__